import React from 'react'
import { SvgIconProps } from './Home'

const NoteIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "24"}
    height={height ?? "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={fill ?? "#003074"}
      d="M17.953 2H6.047A4.05 4.05 0 002 6.047v11.906A4.05 4.05 0 006.047 22h8.558c.744 0 1.488-.28 2-.837l4.558-4.558a2.78 2.78 0 00.837-2V6.047A4.05 4.05 0 0017.953 2zm-1.209 11.907a2.819 2.819 0 00-2.837 2.837v3.116h-7.86a1.916 1.916 0 01-1.907-1.907V6.047c0-1.07.883-1.907 1.907-1.907h11.906c1.07 0 1.907.883 1.907 1.907v7.86h-3.116zm2 2.14l-2.697 2.697v-1.953c0-.419.325-.744.744-.744h1.953z"
    ></path>
    <path
      fill={fill ?? "#003074"}
      d="M16.186 6.744H7.814c-.605 0-1.07.465-1.07 1.07s.465 1.07 1.07 1.07h8.326c.604 0 1.07-.465 1.07-1.07s-.466-1.07-1.024-1.07zM16.186 10.326H7.814c-.605 0-1.07.465-1.07 1.07s.465 1.07 1.07 1.07h8.326c.604 0 1.07-.465 1.07-1.07s-.466-1.07-1.024-1.07z"
    ></path>
  </svg>
)

export default NoteIcon
